import { cx } from './cx';

/** Shared control chrome: Ace .form-control (flat, 34px) with an AA-contrast boundary. */
export const controlClass = (invalid: boolean, valid: boolean) =>
  cx(
    'w-full rounded-ui border bg-surface px-2.5 text-sm text-ink transition-colors duration-150',
    'disabled:cursor-not-allowed disabled:bg-surface-muted disabled:opacity-70',
    invalid ? 'border-danger' : valid ? 'border-success' : 'border-border-strong',
  );
